var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "map-card" }, [
    _c("div", { staticClass: "map-head" }, [
      _c("div", [
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapTitle"))),
        ]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapSubtitle"))),
        ]),
      ]),
      _c("div", { staticClass: "map-meta" }, [
        _c("span", { staticClass: "map-live" }, [
          _c("i"),
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapLive"))),
        ]),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapClickTip"))),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "map-legend" },
      _vm._l(_vm.platformColors, function (color, index) {
        return _c("span", { key: index, staticClass: "legend-chip" }, [
          _c("i", { style: { background: color } }),
          _vm._v(_vm._s(_vm.platformNames[index]) + " "),
        ])
      }),
      0
    ),
    _c("div", { staticClass: "map-layout" }, [
      _c("div", { staticClass: "map-wrap" }, [
        _c("div", { ref: "brazilMap", staticClass: "brazil-map" }, [
          _c(
            "svg",
            {
              staticClass: "brazil-svg",
              attrs: {
                "aria-label": _vm.$t(
                  "collectionOperationDashboard.mapAriaLabel"
                ),
                viewBox: "0 0 520 410",
              },
            },
            [
              _c("g", { ref: "mapViewport" }, [
                _c("path", {
                  staticClass: "country-shadow",
                  attrs: {
                    d: "M145 35 L215 20 L290 35 L360 50 L430 82 L470 130 L455 190 L430 240 L410 285 L385 330 L345 388 L300 372 L268 340 L220 326 L188 286 L165 248 L130 220 L104 175 L90 125 L112 82 Z",
                  },
                }),
                _c(
                  "g",
                  { ref: "statePolygons" },
                  _vm._l(_vm.stateList, function (state) {
                    return _c("path", {
                      key: state.code,
                      class: [
                        "state-shape",
                        _vm.stateOrderClass(state.code),
                        { active: _vm.selectedState === state.code },
                      ],
                      attrs: { d: state.path, "data-state": state.code },
                      on: {
                        click: function ($event) {
                          return _vm.selectState(state.code)
                        },
                        mouseenter: function ($event) {
                          return _vm.showMapTooltip($event, state.code)
                        },
                        mouseleave: _vm.hideMapTooltip,
                        mousemove: function ($event) {
                          return _vm.moveMapTooltip($event)
                        },
                      },
                    })
                  }),
                  0
                ),
                _c(
                  "g",
                  { ref: "stateLabels" },
                  [
                    _vm._l(_vm.stateList, function (state) {
                      return _c(
                        "text",
                        {
                          key: "label-" + state.code,
                          staticClass: "state-label",
                          attrs: { x: state.labelX, y: state.labelY },
                        },
                        [_vm._v(" " + _vm._s(state.code) + " ")]
                      )
                    }),
                    _vm._l(_vm.stateList, function (state) {
                      return _c(
                        "text",
                        {
                          key: "value-" + state.code,
                          staticClass: "state-value",
                          attrs: { x: state.labelX, y: state.labelY + 13 },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatNumber(_vm.stateValue(state.code))
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm.tooltip.visible
            ? _c(
                "div",
                {
                  staticClass: "map-tooltip",
                  style: {
                    left: _vm.tooltip.x + "px",
                    top: _vm.tooltip.y + "px",
                  },
                },
                [
                  _c("div", { staticClass: "tooltip-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.tooltip.state) +
                        " · " +
                        _vm._s(_vm.formatNumber(_vm.tooltip.total)) +
                        _vm._s(_vm.$t("collectionOperationDashboard.piece")) +
                        " "
                    ),
                  ]),
                  _vm._l(_vm.tooltip.details, function (item, i) {
                    return _c("div", { key: i, staticClass: "tooltip-row" }, [
                      _c("i", { style: { background: item.color } }),
                      _c("span", [_vm._v(_vm._s(item.name))]),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.formatNumber(item.value)) +
                            _vm._s(_vm.$t("collectionOperationDashboard.piece"))
                        ),
                      ]),
                    ])
                  }),
                  !_vm.tooltip.details.length
                    ? _c("div", { staticClass: "tooltip-row" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("collectionOperationDashboard.mapNoData")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "map-toolbar" }, [
            _c(
              "button",
              {
                staticClass: "map-tool-btn",
                on: {
                  click: function ($event) {
                    return _vm.zoomMap(1.15)
                  },
                },
              },
              [_vm._v("＋")]
            ),
            _c(
              "button",
              {
                staticClass: "map-tool-btn",
                on: {
                  click: function ($event) {
                    return _vm.zoomMap(0.87)
                  },
                },
              },
              [_vm._v("−")]
            ),
            _c(
              "button",
              {
                staticClass: "map-tool-btn",
                attrs: { title: _vm.$t("GlobalSetObj.reset") },
                on: {
                  click: function ($event) {
                    return _vm.resetMapZoom()
                  },
                },
              },
              [_vm._v(" ↺ ")]
            ),
          ]),
          _c("div", { staticClass: "map-note" }, [
            _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapNote"))),
          ]),
        ]),
      ]),
      _c("aside", { staticClass: "map-summary" }, [
        _c("div", { staticClass: "map-summary-title" }, [
          _c("b", [_vm._v(_vm._s(_vm.mapScope))]),
          _c("span", [_vm._v(_vm._s(_vm.mapMetric))]),
        ]),
        _c("div", { staticClass: "map-total" }, [
          _vm._v(" " + _vm._s(_vm.formatNumber(_vm.mapTotal))),
          _c("small", [
            _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.piece"))),
          ]),
        ]),
        _c("div", { staticClass: "map-stats" }, [
          _c("div", { staticClass: "map-stat" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.coverage"))),
            ]),
            _c("b", [_vm._v(_vm._s(_vm.mapCoverage))]),
          ]),
          _c("div", { staticClass: "map-stat" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.topClient"))),
            ]),
            _c("b", [_vm._v(_vm._s(_vm.mapTopClient))]),
          ]),
        ]),
        _vm.mapUnknownTotal > 0
          ? _c("div", { staticClass: "map-unknown" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("collectionOperationDashboard.unknownStateHint", {
                      count: _vm.formatNumber(_vm.mapUnknownTotal),
                    })
                  ) +
                  " "
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "rank-title" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.ufRanking"))),
          ]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("collectionOperationDashboard.collectVolume"))
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "map-ranking" },
          _vm._l(_vm.mapRanking, function (item) {
            return _c("div", { key: item.name, staticClass: "rank-row" }, [
              _c("span", { staticClass: "rank-uf" }, [
                _vm._v(_vm._s(item.name)),
              ]),
              _c("span", { staticClass: "rank-track" }, [
                _c("i", { style: { width: item.percent + "%" } }),
              ]),
              _c("span", { staticClass: "rank-value" }, [
                _vm._v(_vm._s(_vm.formatNumber(item.value))),
              ]),
            ])
          }),
          0
        ),
        _c("div", { staticClass: "map-foot" }, [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.mapFoot"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }